import { useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type FilterSettingsFabButtonProps = {
  visible: boolean;
  onClick?: () => void;
};

export const FilterSettingsFabButton = ({ visible, onClick }: FilterSettingsFabButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <div
      aria-hidden={!visible}
      inert={!visible}
      className={`z-app-bar fixed right-0 bottom-2 left-0 flex items-center justify-center transition-opacity duration-300 [body:has(.nl-bottom-sheet)_&]:bottom-[5rem] ${visible ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
    >
      <Button color="primary" size="medium" onClick={onClick}>
        <span className="icon-emp-filter" />
        {formatMessage({
          id: 'filters.selection.mobile.filterFabButton.text',
          defaultMessage: 'Filtern & Sortieren',
        })}
      </Button>
    </div>
  );
};
